export default "__VITE_ASSET__C82b2iha__"